import React from "react";
import s from "./styles.module.scss";
import clearLogo from "../../assets/clearlogo.svg";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error Boundary caught an error:", error, errorInfo);

    this.setState({
      error,
      errorInfo,
    });

    // You could also log to an error reporting service here
    // e.g., Sentry, LogRocket, etc.
  }

  handleRefresh = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={s.errorContainer}>
          <div className={s.errorCard}>
            <img src={clearLogo} alt="Ocean" className={s.logo} />
            <h1 className={s.title}>Something went wrong</h1>
            <p className={s.message}>
              We're sorry, but something unexpected happened. Please try refreshing the page.
            </p>

            <div className={s.actions}>
              <button onClick={this.handleRefresh} className={s.primaryButton}>
                Refresh Page
              </button>
              <button onClick={this.handleGoHome} className={s.secondaryButton}>
                Go to Home
              </button>
            </div>

            {process.env.NODE_ENV === "development" && this.state.error && (
              <details className={s.errorDetails}>
                <summary>Error Details (Development Only)</summary>
                <pre>{this.state.error.toString()}</pre>
                {this.state.errorInfo && (
                  <pre>{this.state.errorInfo.componentStack}</pre>
                )}
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
